import type { ReportSectionComment } from '@/data/schemas';

type SectionCommentEntry = ReportSectionComment;

export type SectionCommentUpdates = Record<string, SectionCommentEntry | null>;

export function mergeSectionComments(
  base: Record<string, SectionCommentEntry> | undefined,
  updates: SectionCommentUpdates
): Record<string, SectionCommentEntry> {
  const next: Record<string, SectionCommentEntry> = { ...(base ?? {}) };

  Object.entries(updates).forEach(([sectionId, entry]) => {
    const hasText = Boolean(entry?.text && entry.text.trim().length > 0);
    const hasMedia = (entry?.media?.length ?? 0) > 0;
    if (!entry || (!hasText && !hasMedia)) {
      delete next[sectionId];
      return;
    }

    next[sectionId] = entry;
  });

  return next;
}
